/**
 * override 監視 effect（自動配車の実行中に override が変わったら即キャンセルする。Q2-A）
 * の cancel 判定。
 *
 * Why not `overrideChanged && isBusy` だけにする: `controller.isBusy` は run の受付と
 * 同時に true になる。normal の `onStarted`（未割当からの楽観的除去）は
 * `controller.runNormal` 内で `isRunning(true)` と同じ同期実行の中で呼ばれるため、
 * run 開始直後は「override 変更」と「isBusy: false → true」が同一 commit に乗る。
 * ここで cancel すると、始めたばかりの自分の run を自分で cancel してしまう
 * （Task 8 レビューで検出した回帰）。`wasBusy`（直前レンダーの isBusy）を見て、
 * このレンダーで初めて true になったケースだけを対象外にする。
 *
 * 「受付済み・queued 未確定」の窓（`wasBusy` が既に true）で override が変わった場合は
 * cancel する。旧実装（`asyncPlanningResponse` 経由の `isInFlight`）はこの窓で
 * false のままだったため cancel せず、完了時に override が消えて編集が失われていた。
 * 新しい方が Q2-A の設計意図（実行中の変更は即キャンセルして最新状態で再計算する）に
 * 合うため、この差分は意図した挙動として受け入れる（Task 8 レビューで承認済み）。
 */
export function shouldCancelForOverrideChange({
  overrideChanged,
  isBusy,
  wasBusy,
}: {
  overrideChanged: boolean;
  isBusy: boolean;
  wasBusy: boolean;
}): boolean {
  return overrideChanged && isBusy && wasBusy;
}
